/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { deletePatientFile, uploadPatientFile } from '../../../../../Redux/patients/patientsSlice'
import AttachementCard from './AttachementCard'

const rmSpecialChars = (str) => {
  return str.replace(/[^a-zA-Z0-9]/g, '')
}

const AttachementContent = ({ t, patientId, attachements, selectedOperation }) => {
  const [selectedBFAF, setBFAF] = useState('before')
  const [uploadList, setUploadList] = useState([])
  const dispatch = useDispatch()

  const currentOpInitId = rmSpecialChars(selectedOperation?.init_date) + selectedOperation?.operation_id || 'unknown-opinitid'
  const currentAttachments = attachements?.filter((att) => att?.opinitId === currentOpInitId && att?.type === selectedBFAF)
  const updateListProgress = (id, progress) => {
    if (progress < 100) {
      setUploadList((prev) => {
        return prev.map((file) => {
          if (file.id === id) {
            return {
              ...file,
              progress
            }
          }
          return file
        })
      })
    } else {
      setUploadList((prev) => {
        return prev.filter((file) => file.id !== id)
      })
    }
  }
  const initiateUpload = (e) => {
    const files = e.target.files
    const filesArr = Array.from(files)?.map((file) => ({
      file,
      progress: 0,
      id: Math.random().toString(36).substr(2, 9),
      type: selectedBFAF
    }))
    setUploadList([...uploadList, ...filesArr])
    filesArr.forEach((filedata) => {
      const { file, id, type } = filedata
      dispatch(
        uploadPatientFile({
          file,
          type,
          profileId: patientId,
          opinitId: currentOpInitId,
          onProgress: (value) => updateListProgress(id, value)
        })
      )
    })
  }

  const tryToGetImgUrl = (file) => {
    if (file) {
      try {
        const url = URL.createObjectURL(file)
        return url
      } catch (error) {
        console.log('Error while trying to get image url', error)
        return ''
      }
    }
  }

  const dlAttachement = (attach) => {
    const { url } = attach
    const link = document.createElement('a')
    link.href = url
    link.download = 'download'
    document.body.appendChild(link)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
  }

  const deleteAttachement = (attach) => {
    const { path } = attach
    dispatch(deletePatientFile({ path, profileId: patientId }))
  }

  return (
    <div className={styles.main_content}>
      <div className={styles.content_header_control}>
        <div className={styles.bf_af_selector}>
          <button
            className={`${styles.bf_af_selector_btn} ${styles.before_btn} ${selectedBFAF === 'before' ? styles.active : ''}`}
            onClick={() => setBFAF('before')}
          >
            {t('before')}
          </button>
          <button
            className={`${styles.bf_af_selector_btn} ${styles.after_btn} ${selectedBFAF === 'after' ? styles.active : ''}`}
            onClick={() => setBFAF('after')}
          >
            {t('after')}
          </button>
        </div>
      </div>
      <ul className={styles.content_listing}>
        {currentAttachments?.map((attach, idx) => {
          const { path } = attach
          return <AttachementCard t={t} key={path} attach={attach} dlAttachement={dlAttachement} deleteAttachement={deleteAttachement} />
        })}
        {uploadList.map((file) => {
          return (
            <li key={file.id} className={styles.content_item}>
              <img className={styles.attachment_img} src={tryToGetImgUrl(file.file)} alt='Patient' />
              <div className={styles.pfp_loading_container}>
                <div
                  className={styles.pfp_loading}
                  style={{
                    left: file.progress + '%'
                  }}
                ></div>
              </div>
            </li>
          )
        })}
        <li className={`${styles.content_item} ${styles.upload_btn}`}>
          <label htmlFor='file-attachement-upload' className={styles.upload_label}>
            +
          </label>
          <input onChange={initiateUpload} multiple type='file' id='file-attachement-upload' style={{ display: 'none' }} />
        </li>
      </ul>
    </div>
  )
}
export default AttachementContent
